// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewRef, HostListener, ViewChild, ViewEncapsulation, Optional } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef, MatOptionSelectionChange } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
// RxJS
import { Observable, BehaviorSubject, Subject, Subscription, ReplaySubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// NGRX
// Service
import { SubheaderService } from 'app/core/_base/layout';
import { LayoutUtilsService, MessageType, QueryParamsModel } from 'app/core/_base/crud';
import { DeNghiChuyenKhoService } from '../de-nghi-chuyen-kho-service/de-nghi-chuyen-kho.service';
//Models
import { DeNghiChuyenKhoModel } from '../de-nghi-chuyen-kho-model/de-nghi-chuyen-kho.model';
import { DeNghiChuyenKhoCTModel } from '../de-nghi-chuyen-kho-model/de-nghi-chuyen-kho.model';
import { DatePipe } from '@angular/common';
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { FunctionPublic } from './../../../dung-chung/__function/common_function';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import moment from 'moment';
import { DeNghiChuyenKhoChiTietHangComponent } from '../de-nghi-chuyen-kho-chi-tiet-hang/de-nghi-chuyen-kho-chi-tiet-hang.component'
import { DeNghiChuyenKhoHistoryHHKhoXuatComponent } from '../de-nghi-chuyen-kho-history-hh-khoxuat/de-nghi-chuyen-kho-history-hh-khoxuat.component'
import { DeNghiChuyenKhoHistoryHHKhoNhapComponent } from '../de-nghi-chuyen-kho-history-hh-khonhap/de-nghi-chuyen-kho-history-hh-khonhap.component'
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { NhapQuyTrinhDuyetService } from '../../../quy-trinh/nhap-quy-trinh-duyet/Services/nhap-quy-trinh-duyet.service';

@Component({
	selector: 'kt-de-nghi-chuyen-kho-edit-page',
	templateUrl: './de-nghi-chuyen-kho-edit-page.component.html',
	styleUrls: ['../de-nghi-chuyen-kho.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class DeNghiChuyenKhoEditPageComponent implements OnInit, OnDestroy {
	/*Config Form */
	CONFIG: CommonConFig;
	// Public properties
	/*------------------------ Danh sách ĐVT -----------------------------*/
	listDVT: any[] = [];
	selectListDVT: string = '';
	filteredListDVT: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListDVTFilterCtrl: string = '';
	haveElementListDVT: boolean = false;
	textQuiDoiDVT = '';
	soLuongDaQuiDoi = 0;
	soLuong = 0;
	/* ------------------------------------------------------------------ */
	DeNghiChuyenKho: DeNghiChuyenKhoModel;
	DeNghiChuyenKhoForm: FormGroup;
	DeNghiChuyenKhoCT: DeNghiChuyenKhoCTModel;
	DeNghiChuyenKhoCTForm: FormGroup;
	hasFormErrors: boolean = false;
	loadingSubject = new BehaviorSubject<boolean>(true);
	loading$: Observable<boolean>;
	viewLoading: boolean = false;
	isChange: boolean = false;
	fixedPoint = 2;
	isZoomSize: boolean = false;
	listPhongBanDeNghi: any[] = [];
	selectPhongBanDeNghi: string[] = [];
	filteredPhongBanDeNghi: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	PhongBanDeNghiFilterCtrl: string = '';
	haveElementPhongBanDeNghi: boolean = false;
	listHangHoaId: any[] = [];
	selectId_HH: string = "";
	filteredHangHoaId: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	HangHoaIdFilterCtrl: string = '';
	haveElementHangHoaId: boolean = false;
	arrHangHoa: any[] = []
	listKhoChuyen: any[] = [];
	selectKhoChuyen: string[] = [];
	filteredKhoChuyen: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoChuyenFilterCtrl: string = '';
	haveElementKhoChuyen: boolean = false;
	listKhoNhan: any[] = [];
	selectKhoNhan: string[] = [];
	filteredKhoNhan: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoNhanFilterCtrl: string = '';
	haveElementKhoNhan: boolean = false;
	listTinhTrangCT: any[] = [];
	selectTinhTrangCT: string[] = [];
	filteredTinhTrangCT: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	TinhTrangCTFilterCtrl: string = '';
	haveElementTinhTrangCT: boolean = false;
	displayedColumns: string[] = [];
	availableColumns = [
		{
			stt: 2,
			name: '#',
			isShow: true
		},
		{
			stt: 2,
			name: 'MaHang',
			isShow: true
		},
		{
			stt: 2,
			name: 'TenHang',
			isShow: true
		},
		{
			stt: 2,
			name: 'QuyCach',
			isShow: true
		},
		{
			stt: 2,
			name: 'TenDVT',
			isShow: true
		},
		{
			stt: 2,
			name: 'TenKhoChuyen',
			isShow: true
		},
		// {
		// 	stt: 2,
		// 	name: 'SLThucXuat',
		// 	isShow: true
		// },
		{
			stt: 2,
			name: 'TenKhoNhan',
			isShow: true
		},
		// {
		// 	stt: 2,
		// 	name: 'SLThucNhap',
		// 	isShow: true
		// },
		{
			stt: 2,
			name: 'SoLuong',
			isShow: true
		},
		{
			stt: 2,
			name: 'SoLo',
			isShow: true
		},
		{
			stt: 2,
			name: 'SoMay',
			isShow: true
		},
		{
			stt: 2,
			name: 'MaSub',
			isShow: true
		},
		{
			stt: 2,
			name: 'SoMeSoXe',
			isShow: true
		},
		{
			stt: 2,
			name: 'MaThung',
			isShow: true
		},
		{
			stt: 2,
			name: 'Ngaysanxuat',
			isShow: true
		},
		{
			stt: 2,
			name: 'Hansudung',
			isShow: true
		},
		{
			stt: 2,
			name: 'GhiChu',
			isShow: true
		},
		{
			stt: 4,
			name: 'actions',
			isShow: true
		}
	];
	sumColums: string[] = ['#', 'SoLuong'];

	previousIndex: number;
	idcocaupb: any;
	userinfor: any = {};
	namenguoitao: string = '';
	ArrayIdNumber: number[] = [];
	private componentSubscriptions: Subscription;
	disabledAddBtn: boolean = false;
	tmpDeNghiChuyenKhoCT: DeNghiChuyenKhoCTModel[] = [];
	optionsTinhTrang = [
		{
			id: 1,
			name: 'Đang soạn thảo',
			value: 'DNCK_DANGSOANTHAO',
		},
		{
			id: 2,
			name: 'Chờ duyệt',
			value: 'DNCK_CHODUYET',
		},
		{
			id: 2,
			name: 'Không duyệt',
			value: 'DNCK_KHONGDUYET',
		},
		{
			id: 2,
			name: 'Đang thực hiện',
			value: 'DNCK_DANGTHUCHIEN',
		},
		{
			id: 3,
			name: 'Hoàn tất',
			value: 'DNCK_HOANTAT',
		},
		{
			id: 4,
			name: 'Đã hủy',
			value: 'DNCK_DAHUY',
		},
	];
	getdatenow: Date = new Date();
	queryParams: QueryParamsModel;
	loaiHH: any[] = [
		{
			name: "Nguyên Liệu",
			value: '1'
		},
		{
			name: "Phụ Liệu",
			value: '2'
		},
		{
			name: "Hóa Chất",
			value: '3'
		},
		{
			name: "Thành Phẩm",
			value: '4'
		},
		{
			name: "Bán Thành Phẩm",
			value: '5'
		},
		{
			name: "Bao Bì",
			value: '6'
		},
		{
			name: "Văn Phòng Phẩm",
			value: '7'
		},
		{
			name: "Vật Tư",
			value: '8'
		},
		{
			name: "Tài Sản",
			value: '9'
		},
		{
			name: "Công Cụ Dụng Cụ",
			value: '10'
		},
		{
			name: "Trang Thiết Bị",
			value: '11'
		},
		{
			name: "Phụ Gia",
			value: '12'
		},
		{
			name: "Nhiên liệu",
			value: '13'
		},
	]
	path: string = 'DNCK';
	selection = new SelectionModel<DeNghiChuyenKhoCTModel>(true, []);
	saveAddedCT: number[] = []
	//open dialog đề nghị chuyển kho
	openDialogDNChuyenKho: boolean = false
	//-------Begin CdkVirtualScrollViewport-------
	@ViewChild(CdkVirtualScrollViewport, { static: false })
	cdkVirtualScrollViewPort: CdkVirtualScrollViewport;
	//-------End CdkVirtualScrollViewport-------
	// TREE
	public datatree: BehaviorSubject<any[]> = new BehaviorSubject([]);
	ID_Struct: string = '';
	show_rooms = new BehaviorSubject<boolean>(false);
	orgStructureTree: any[] = [];
	
	// Init Array List KeyWords Search In List Details
	keyWordSearchInListFrom: any[] = [];
	keyWordSearchInListTo: any[] = [];

	keywordChanged: Subject<string> = new Subject<string>();
	loadingMerchandise = new BehaviorSubject<boolean>(false);
	fakeOptionNumber: number = 5;
	isCopy: boolean = false;
	sltRequestDepartment: string = "";
	ftrRequestDepartment: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	requestDepartmentFtrCtrl: string = '';
	constructor(
		private DeNghiChuyenKhoFB: FormBuilder,
		private DeNghiChuyenKhoCTFB: FormBuilder,
		public dialog: MatDialog,
		private layoutUtilsService: LayoutUtilsService,
		private changeDetectorRefs: ChangeDetectorRef,
		private changeDetect: ChangeDetectorRef,
		private datePipe: DatePipe,
		private tokenStorage: TokenStorage,
		private serMaster: DungChungService,
		private denghichuyenkhosService: DeNghiChuyenKhoService,
		private route: ActivatedRoute,
		private router: Router,
		private subheaderService: SubheaderService,
		private treeService: NhapQuyTrinhDuyetService,

	) {
		// ------ Hàm làm mới danh sách hàng hóa mỗi khi search
		if(this.keywordChanged){
			this.keywordChanged
			.pipe(
				debounceTime(500),
				distinctUntilChanged() 
			)
			.subscribe(value => {
				this.ListHangHoaId(value);
			});
		}
	}
	/**
	 * On init
	 */
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		/*Handel keydown event in dialog*/
		this.tokenStorage.getFullName().subscribe(name => { this.namenguoitao = name })
		this.tokenStorage.getCoCauId().subscribe(cocau => { this.idcocaupb = cocau })
		this.tokenStorage.getUserInfo().subscribe(infor => { this.userinfor = infor });
		this.viewLoading = false;
		this.getTree();
		this.ListPhongBanDeNghi();
		
		this.ListHangHoaId();
		this.ListDVT();
		this.Loadcolumntable();
		this.getListWareHouse();
		this.DeNghiChuyenKho = new DeNghiChuyenKhoModel();
		this.DeNghiChuyenKho.clear();
		this.route.params.subscribe(params => {
			if(params.id != undefined){
				this.DeNghiChuyenKho.Id = +params.id;
			}
		});
		if(this.DeNghiChuyenKho.Id == 0){
			var data = window.history.state
			if(data){
				this.DeNghiChuyenKho.Id = data.Id
				this.isCopy = true;
			}
		}
		this.DeNghiChuyenKhoCT = new DeNghiChuyenKhoCTModel();
		this.DeNghiChuyenKhoCT.clear();
		if (Number(this.DeNghiChuyenKho.Id) > 0 && !this.isCopy) {
			let breadcrumbs = [{ title: 'Kho' }, { title: 'Đề nghị chuyển kho', page: '/de-nghi-chuyen-kho' },
			{ title: `Chỉnh sửa`, page: '/de-nghi-chuyen-kho/chinh-sua/'+this.DeNghiChuyenKho.Id}];
			this.subheaderService.setBreadcrumbs(breadcrumbs);
		} else {
			let breadcrumbs = [{ title: 'Kho' }, { title: 'Đề nghị chuyển kho', page: '/de-nghi-chuyen-kho' },
			{ title: `Thêm mới`, page: '/de-nghi-chuyen-kho/them-moi' }];
			this.subheaderService.setBreadcrumbs(breadcrumbs);
		}
		this.createForm();
		this.generateAutoSoPhieu();
		this.DeNghiChuyenKhoCTForm.get("maHang").valueChanges.subscribe(
			(newValue) => {
				this.filterHangHoaId(newValue);
			}
		);
		if ((this.DeNghiChuyenKho.Id) > 0) {
			this.denghichuyenkhosService.getDeNghiChuyenKhoById(this.DeNghiChuyenKho.Id).subscribe(res => {
				if (res.status == 1 && res.data) {
					this.DeNghiChuyenKho = res.data;
					
					if (this.DeNghiChuyenKho.TrangThai != this.optionsTinhTrang[0].value && !this.isCopy) {
						this.back_404();
						return;
					}
					if (this.DeNghiChuyenKho.Id > 0){
						let breadcrumbs = [{ title: 'Kho' }, { title: 'Đề nghị chuyển kho', page: '/de-nghi-chuyen-kho' },
						{ title: `Chỉnh sửa`, page: '/de-nghi-chuyen-kho/chinh-sua/'+this.DeNghiChuyenKho.Id }];
						this.subheaderService.setBreadcrumbs(breadcrumbs);
					} else {
						let breadcrumbs = [{ title: 'Kho' }, { title: 'Đề nghị chuyển kho', page: '/de-nghi-chuyen-kho' },
						{ title: `Thêm mới`, page: '/de-nghi-chuyen-kho/them-moi' }];
						this.subheaderService.setBreadcrumbs(breadcrumbs);
					}
					if(this.isCopy){
						this.DeNghiChuyenKho.Id = 0;
					}
					this.createForm();
					this.changeDetectorRefs.detectChanges();
				}
			});
		}
		this.DeNghiChuyenKhoForm.get('phongBanDeNghi').valueChanges.subscribe(newValue=>{
			if(newValue == 9999){
				this.DeNghiChuyenKhoForm.controls["TenPbKhac"].enable();
				this.DeNghiChuyenKhoForm.controls["TenPbKhac"].setValidators(Validators.required);
			}
            else{
				this.DeNghiChuyenKhoForm.controls["TenPbKhac"].disable();
				this.DeNghiChuyenKhoForm.controls["TenPbKhac"].updateValueAndValidity();

			}
			this.changeDetectView();
		});
	}
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.key == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.description && !this.openDialogDNChuyenKho) {
			
			if(this.tmpDeNghiChuyenKhoCT.length > 0){
				const dialogRef = this.layoutUtilsService.POPConfirm(
					"Các thông tin vừa chỉnh sửa sẽ bị mất nếu bạn không lưu lại?"
				);
	
				dialogRef.afterClosed().subscribe((res) => {
					if (!res) {
						return;
					}
					this.back();				
				});
			}
			else{
				this.back();
			}
		}
		else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_CLOSE.KeyCombine.keycode) {
			this.onSubmit(1);
		}
		else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_NEW.KeyCombine.keycode) {
			this.onSubmit(2);
		}
		else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_TMP.KeyCombine.keycode) {
			this.onSubmit(0);
		}
		else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.ADD_MATHANG.KeyCombine.keycode && !(this.DeNghiChuyenKhoCTForm.invalid) && !(this.formatComparenumber(this.DeNghiChuyenKhoCTForm.controls['soLuong'].value + '') > this.formatComparenumber(this.DeNghiChuyenKhoCTForm.controls['sLTon'].value + ''))) {
			this.addDetailDeNghiChuyenKho();
		}
		this.changeDetect.detectChanges();
	}
	/**
	 * On destroy
	 */
	ngOnDestroy() {
		if (this.componentSubscriptions) {
			this.componentSubscriptions.unsubscribe();
		}
	}
	/**
	 * Create form
	 */
	createForm() {
		this.DeNghiChuyenKhoForm = this.DeNghiChuyenKhoFB.group({
			soPhieu: [(this.DeNghiChuyenKho.SoPhieu == null || this.DeNghiChuyenKho.SoPhieu == '') ? '' : this.DeNghiChuyenKho.SoPhieu],
			ngayTao: [(this.DeNghiChuyenKho.NgayTao == null || this.DeNghiChuyenKho.NgayTao == '') ? this.FormatDatetime(this.getdatenow) : this.FormatDatetime(this.DeNghiChuyenKho.NgayTao)],
			tenNguoiTao: [(this.DeNghiChuyenKho.TenNguoiTao == null || this.DeNghiChuyenKho.TenNguoiTao == '') ? this.namenguoitao : this.DeNghiChuyenKho.TenNguoiTao],
			trangThai: [(this.DeNghiChuyenKho.TrangThai == null || this.DeNghiChuyenKho.TrangThai == '') ? this.convertTitleTinhTrang(this.optionsTinhTrang[0].value) : this.convertTitleTinhTrang(this.DeNghiChuyenKho.TrangThai)],
			phongBanDeNghi: [(this.DeNghiChuyenKho.PhongBanDeNghi == null || this.DeNghiChuyenKho.PhongBanDeNghi == 0) ? this.idcocaupb + '' : this.DeNghiChuyenKho.PhongBanDeNghi.toString(), Validators.required],
			ngayChuyen: [(this.DeNghiChuyenKho.NgayChuyen == null || this.DeNghiChuyenKho.NgayChuyen == '') ? this.getdatenow : this.DeNghiChuyenKho.NgayChuyen, Validators.required],
			LyDo: [(this.DeNghiChuyenKho.LyDo == null || this.DeNghiChuyenKho.LyDo == '') ? '' : this.DeNghiChuyenKho.LyDo,  Validators.required],
			TenPbKhac: [(this.DeNghiChuyenKho.TenPbKhac == null || this.DeNghiChuyenKho.TenPbKhac == '') ? '' : this.DeNghiChuyenKho.TenPbKhac,  Validators.required],

		});
		if(this.isCopy){
			this.generateAutoSoPhieu();
		}
		this.DeNghiChuyenKhoCTForm = this.DeNghiChuyenKhoCTFB.group({
			maHang: ['', Validators.required],
			tenHang: [''],
			quyCach: [''],
			//tenDVT: [''],
			khoChuyen: ['', Validators.required],
			khoNhan: ['', Validators.required],
			sLTon: [(this.DeNghiChuyenKhoCT.SLTon == null || this.DeNghiChuyenKhoCT.SLTon == 0) ? '0,00' : this.DeNghiChuyenKhoCT.SLTon],
			//soLuong: [(this.DeNghiChuyenKhoCT.SoLuong == null || this.DeNghiChuyenKhoCT.SoLuong == 0) ? '0,00' : this.DeNghiChuyenKhoCT.SoLuong, Validators.compose([Validators.required, Validators.maxLength(24), Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER)])],
			DVTQuiDoi: ["", Validators.required],
			SoLuongQuiDoi: [
				FunctionPublic.TEXT_MIN_POINT,
				Validators.compose([
					Validators.required,
					Validators.maxLength(24),
					Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER_NOTREQUIREDNEW),
				]),
			],
			soLo: [(this.DeNghiChuyenKhoCT.SoLo == null || this.DeNghiChuyenKhoCT.SoLo == '') ? '' : this.DeNghiChuyenKhoCT.SoLo],
			soMay: [(this.DeNghiChuyenKhoCT.SoMay == null || this.DeNghiChuyenKhoCT.SoMay == '') ? '' : this.DeNghiChuyenKhoCT.SoMay],
			ghiChu: [(this.DeNghiChuyenKhoCT.GhiChu == null || this.DeNghiChuyenKhoCT.GhiChu == '') ? '' : this.DeNghiChuyenKhoCT.GhiChu],
			MaSub: [(this.DeNghiChuyenKhoCT.MaSub == null || this.DeNghiChuyenKhoCT.MaSub == '') ? '' : this.DeNghiChuyenKhoCT.MaSub],
			SoMeSoXe: [(this.DeNghiChuyenKhoCT.SoMeSoXe == null || this.DeNghiChuyenKhoCT.SoMeSoXe == '') ? '' : this.DeNghiChuyenKhoCT.SoMeSoXe],
			MaThung: [(this.DeNghiChuyenKhoCT.MaThung == null || this.DeNghiChuyenKhoCT.MaThung == '') ? '' : this.DeNghiChuyenKhoCT.MaThung],
			Ngaysanxuat: [(this.DeNghiChuyenKhoCT.Ngaysanxuat == null || this.DeNghiChuyenKhoCT.Ngaysanxuat == '') ? '' : this.DeNghiChuyenKhoCT.Ngaysanxuat],
			Hansudung: [(this.DeNghiChuyenKhoCT.Hansudung == null || this.DeNghiChuyenKhoCT.Hansudung == '') ? '' : this.DeNghiChuyenKhoCT.Hansudung],

		});
		let controls = this.DeNghiChuyenKhoForm.controls;
		controls['TenPbKhac'].disable();
		let controlsCT = this.DeNghiChuyenKhoCTForm.controls;
		controls['soPhieu'].disable();
		controls['ngayTao'].disable();
		controls['tenNguoiTao'].disable();
		controls['trangThai'].disable();
		controlsCT['tenHang'].disable();
		controlsCT['DVTQuiDoi'].disable();
		controlsCT['quyCach'].disable();
		//controlsCT['tenDVT'].disable();
		controlsCT['sLTon'].disable();
		if (this.DeNghiChuyenKho.listDeNghiChuyenKhoCT.length > 0) {
			this.tmpDeNghiChuyenKhoCT=[];
			this.DeNghiChuyenKho.listDeNghiChuyenKhoCT.forEach(element => {
				element.SoLuong = this.f_number(element.SoLuong);
				element.SLTon = this.f_number(element.SLTon);
				element.ListKhoChuyen = element.ListChuyenKho;
				if(element.isDisableHH){
					element.isError = true;
					element.messageError = "Mặt hàng không còn tồn tại!"
				}
				if(this.isCopy){
					element.DvtQuiDoi = element.DvtCopy;
					element.DaLapPhieuChuyenKho = false;
				}
				this.tmpDeNghiChuyenKhoCT.push(element);
				this.keyWordSearchInListFrom.push("");
				this.keyWordSearchInListTo.push("");
			});
			this.tmpDeNghiChuyenKhoCT = [...this.tmpDeNghiChuyenKhoCT];
			
		}
		this.changeDetectView();
	}
	getColSpan(){
		return this.displayedColumns.indexOf("SLThucNhap")
	}
	getTotalNumber(){
	 let total = 0;
	 this.tmpDeNghiChuyenKhoCT.forEach(element => {
		total += Number(element.SLThucNhap)
	 });
	 return total;
	}
	getTotalNumber2(){
		let total = 0;
		this.tmpDeNghiChuyenKhoCT.forEach(element => {
		   total += Number(element.SoLuongQuiDoi)
		});
		return total;
	}
	/**
	 * Returns page title
	 */
	getTitle(): string {
		if (this.DeNghiChuyenKho && this.DeNghiChuyenKho.Id > 0) {
			return `Chỉnh sửa phiếu đề nghị chuyển kho `;
		}
		return 'Thêm mới phiếu đề nghị chuyển kho';
	}
	/**
	 * Check control is invalid
	 * @param controlName: string
	 */
	isControlInvalid(controlName: string): boolean {
		const control = this.DeNghiChuyenKhoForm.controls[controlName];
		const result = control.invalid && control.touched;
		return result;
	}
	/**
	 * Save data
	 *
	 * @param withBack: boolean
	 */
	scrollToTop(){
		setTimeout(() => {
			window.scrollTo({top: document.body.scrollTop, behavior: 'smooth' });
		}, 200);
	}

	onSubmit(status: number) {
		this.hasFormErrors = false;
		const controls = this.DeNghiChuyenKhoForm.controls;
		/** check form */
		
		if (this.DeNghiChuyenKhoForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
			if(this.DeNghiChuyenKhoForm.controls['LyDo'].value == "" || this.DeNghiChuyenKhoForm.controls['LyDo'].value == null){
				const message = `Vui lòng nhập lý do.`;
				this.layoutUtilsService.showErorr(message);
				this.scrollToTop()
			}
			return;
		}
		if(this.DeNghiChuyenKhoForm.controls['phongBanDeNghi'].value == 9999 &&  this.DeNghiChuyenKhoForm.controls['TenPbKhac'].value == ''){
			this.hasFormErrors = true;
			const message = `Vui lòng nhập tên phòng ban khác.`;
			this.layoutUtilsService.showErorr(message);
			return;
		}
		if (this.tmpDeNghiChuyenKhoCT.length == 0) {
			const message = `Vui lòng thêm hàng.`;
			this.layoutUtilsService.showErorr(message);
			return;
		}

		// Kiểm tra chi tiết 
		for(var i = 0; i < this.tmpDeNghiChuyenKhoCT.length; i++) {
			var item = this.tmpDeNghiChuyenKhoCT[i];
			if(!item.KhoChuyen || !item.KhoNhan || !Number(item.SoLuongQuiDoi)){
				this.layoutUtilsService.showErorr("Vui lòng kiểm tra lại dữ liệu ở dòng thứ "+(i+1)+" trước khi lưu");
				return;
			}
			if(item.isError){
				this.layoutUtilsService.showErorr("Vui lòng kiểm tra lại dữ liệu ở dòng thứ "+(i+1)+" trước khi lưu");
				return;
			}
		}

		// tslint:disable-next-line:prefer-const
		let editedDeNghiChuyenKho = this.prepareDeNghiChuyenKhos(status);
		if (this.DeNghiChuyenKho.Id > 0) {
			if (status == 1 || status == 2) {
				const dialogRef = this.layoutUtilsService.POP02(editedDeNghiChuyenKho.SoPhieu);
				dialogRef.afterClosed().subscribe(res => {
					if (!res) {
						return;
					}
					this.updateDeNghiChuyenKho(editedDeNghiChuyenKho, status)
				});
			} else {
				this.updateDeNghiChuyenKho(editedDeNghiChuyenKho, status)
			}
			return;
		}
		if (status == 1 || status == 2) {
			const dialogRef = this.layoutUtilsService.POP02(editedDeNghiChuyenKho.SoPhieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				this.addDeNghiChuyenKho(editedDeNghiChuyenKho, status);
			});
		} else {
			this.addDeNghiChuyenKho(editedDeNghiChuyenKho, status);
		}
	}
	/**
	 * Returns object for saving
	 */
	prepareDeNghiChuyenKhos(status: number): DeNghiChuyenKhoModel {
		const controls = this.DeNghiChuyenKhoForm.controls;
		const _DeNghiChuyenKho = new DeNghiChuyenKhoModel();
		_DeNghiChuyenKho.clear();
		_DeNghiChuyenKho.SoPhieu = controls['soPhieu'].value;
		_DeNghiChuyenKho.NgayTao = moment(this.getdatenow).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		_DeNghiChuyenKho.TenNguoiTao = controls['tenNguoiTao'].value;
		_DeNghiChuyenKho.TrangThai = this.convertCodeTinhTrang(status);
		_DeNghiChuyenKho.LyDo = controls['LyDo'].value;
		_DeNghiChuyenKho.PhongBanDeNghi = Number(controls['phongBanDeNghi'].value);
		_DeNghiChuyenKho.TenPbKhac = controls['TenPbKhac'].value;
		_DeNghiChuyenKho.NgayChuyen = moment(controls['ngayChuyen'].value).format('YYYY-MM-DD[T]HH:mm:ss.SSS')
		_DeNghiChuyenKho.countChoDongAndChoDuyet = '0';
		_DeNghiChuyenKho.listDeNghiChuyenKhoCT = JSON.parse(JSON.stringify(this.tmpDeNghiChuyenKhoCT));
		_DeNghiChuyenKho.listDeNghiChuyenKhoCT.forEach(element => {
			element.SoLuong = Number(element.SoLuong);
			element.SLThucXuat = Number(element.SLThucXuat);
			element.SLThucNhap = Number(element.SLThucNhap);
			element.SLTon = Number(this.f_number(element.SLTon));
			element.KhoNhan = Number(element.KhoNhan);
			element.KhoChuyen = Number(element.KhoChuyen);
			element.HangHoaId = Number(element.HangHoaId);
			element.Id = Number(element.Id);
			if(element.Hansudung){
				element.Hansudung = moment(new Date(element.Hansudung)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
			}
			if(element.Ngaysanxuat){
				element.Ngaysanxuat = moment(new Date(element.Ngaysanxuat)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
			}
			delete element.ListKhoChuyen;
		});
		//gán lại giá trị id 
		if (this.DeNghiChuyenKho.Id > 0) {
			_DeNghiChuyenKho.Id = this.DeNghiChuyenKho.Id;
		}
		return _DeNghiChuyenKho;
	}
	/**
	 * Add item
	 *
	 * @param _DeNghiChuyenKho: DeNghiChuyenKhoModel
	 * @param withBack: boolean
	 */
	addDeNghiChuyenKho(_DeNghiChuyenKho: DeNghiChuyenKhoModel, status) {
		this.disabledAddBtn = true;
		this.denghichuyenkhosService.createDeNghiChuyenKho(_DeNghiChuyenKho).subscribe(res => {
			if (res.status == 1) {
				this.isChange = true;
				const message = `Đề nghị chuyển kho mới đã được thêm.`;
				this.layoutUtilsService.showInfo(message);
				if (this.ArrayIdNumber.findIndex(x => x == res.data.Id) == -1) {
					this.ArrayIdNumber.push(res.data.Id);
				}
				this.disabledAddBtn = false;
				if (status == 1) {
					this.back();
				} else if (status == 2) {
					this.DeNghiChuyenKho = new DeNghiChuyenKhoModel();
					this.DeNghiChuyenKho.clear();
					this.DeNghiChuyenKhoForm.reset();
					this.DeNghiChuyenKho.Id = 0;
					this.tmpDeNghiChuyenKhoCT = [];
					this.tmpDeNghiChuyenKhoCT = [...this.tmpDeNghiChuyenKhoCT];
					this.createForm();
					this.generateAutoSoPhieu();
					this.changeDetectView();
				} else {
					this.DeNghiChuyenKho.Id = res.data.Id;
					this.denghichuyenkhosService.getDeNghiChuyenKhoById(this.DeNghiChuyenKho.Id).subscribe(res => {
						if (res.status == 1 && res.data) {
							this.DeNghiChuyenKho = res.data;
							this.createForm();
							this.changeDetectorRefs.detectChanges();
						}
					});
					this.changeDetectView();
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	/**
	 * Update item
	 *
	 * @param _DeNghiChuyenKho: DeNghiChuyenKhosModel
	 * @param withBack: boolean
	 */
	updateDeNghiChuyenKho(_DeNghiChuyenKho: DeNghiChuyenKhoModel, status: number) {
		this.disabledAddBtn = true;
		this.denghichuyenkhosService.updateDeNghiChuyenKho(_DeNghiChuyenKho).subscribe(res => {
			if (res.status == 1) {
				this.isChange = true;
				const message = `Đề nghị chuyển kho `+_DeNghiChuyenKho.SoPhieu+` đã được cập nhật`;
				this.layoutUtilsService.showInfo(message);
				this.disabledAddBtn = false;
				if (this.ArrayIdNumber.findIndex(x => x == res.data.Id) == -1) {
					this.ArrayIdNumber.push(res.data.Id);
				}
				if (status == 1) {
					this.back();
				} else if (status == 2) {
					this.DeNghiChuyenKho = new DeNghiChuyenKhoModel();
					this.DeNghiChuyenKho.clear();
					this.DeNghiChuyenKho.Id = 0;
					this.DeNghiChuyenKhoForm.reset();
					this.tmpDeNghiChuyenKhoCT = [];
					this.tmpDeNghiChuyenKhoCT = [...this.tmpDeNghiChuyenKhoCT];
					this.createForm();
					this.generateAutoSoPhieu();
					this.changeDetectView();
				} else {
					this.DeNghiChuyenKho.Id = res.data.Id;
					this.denghichuyenkhosService.getDeNghiChuyenKhoById(this.DeNghiChuyenKho.Id).subscribe(res => {
						if (res.status == 1 && res.data) {
							this.DeNghiChuyenKho = res.data;
							this.createForm();
							this.changeDetectorRefs.detectChanges();
						}
					});
					this.changeDetectView();
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	/**
	 * Close alert
	 *
	 * @param $event
	 */
	onAlertClose($event) {
		this.hasFormErrors = false;
	}
	numberOnly(event): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}
	ListPhongBanDeNghi() {
		this.denghichuyenkhosService.listPhongBanDeNghi().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listPhongBanDeNghi = res.data;
				let item = {
					Id_PB: 9999,
					TenPB: 'KHÁC'
				}
				this.listPhongBanDeNghi.push(item);
				this.filteredPhongBanDeNghi.next(this.listPhongBanDeNghi.slice());
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	getTree(){
		this.treeService.Get_CoCauToChuc().subscribe(res => {
			if (res.data && res.data.length > 0) {
				let item = {
					Id_PB: 9999,
					TenPB: 'KHÁC'
				};
				res.data.push(item);
				this.datatree.next(res.data);
				this.orgStructureTree = res.data[0] ? this.balanceStructureTree(res.data[0], []) : [];
				this.orgStructureTree.push(item);
				this.ftrRequestDepartment.next([...this.orgStructureTree]);
				this.changeDetectView();
			}
		});
	}
	// ..............................................................
	balanceStructureTree(data, orgStructureTree: any[], level: number = 0) {
		if (!data) return;
		if (data) {
			if (level > 0){ // .. Loại bỏ Cty TNHH thực phẩm NFC
				orgStructureTree.push({
					Id_PB: data["Id_PB"],
					TenPB: data["TenPB"]
				});
			}
			if (data.Childrens && data.Childrens.length > 0) {
				data.Childrens.forEach(child => {
					this.balanceStructureTree(child, orgStructureTree, level + 1);
				})
			}
		}
		return orgStructureTree;
	}
	filterPhongBanDeNghi() {
		if (!this.listPhongBanDeNghi) {
			return;
		}
		// get the search keyword
		let search = this.PhongBanDeNghiFilterCtrl;
		if (!search) {
			this.filteredPhongBanDeNghi.next(this.listPhongBanDeNghi.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredPhongBanDeNghi.next(
			this.listPhongBanDeNghi.filter(ts =>
				ts.TenPB.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	ListHangHoaId(keyword: string = "", top: number = 0) {
		this.loadingMerchandise.next(true);
		this.serMaster.top_list_of_merchandise_lite(keyword, top).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listHangHoaId = res.data;
				console.log(res.data)
				this.filteredHangHoaId.next(this.listHangHoaId.slice());
				// this.arrHangHoa.push(this.filteredHangHoaId);
			};
			this.changeDetectorRefs.detectChanges();
			this.loadingMerchandise.next(false);
			this.loadingSubject.next(true);
		});
	}
	filterHangHoaId(searchTmp: string = "") {
		let tmpListHH = [];
		tmpListHH = this.listHangHoaId;
		if (!tmpListHH) {
			return;
		}
		// get the search keyword
		let search = this.HangHoaIdFilterCtrl;
		if (searchTmp != "") search = "" + searchTmp;
		if (!search) {
			this.filteredHangHoaId.next(tmpListHH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		if (searchTmp != "") {
			this.filteredHangHoaId.next(
				tmpListHH.filter(
					(ts) => ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1
				)
			);
		} else {
			this.filteredHangHoaId.next(
				tmpListHH.filter(
					(ts) => ts.MaHH.toLowerCase().indexOf(search) > -1
				)
			);
		}
		this.changeDetect.detectChanges();
	}

	ListKhoChuyen() {
		let controls = this.DeNghiChuyenKhoCTForm.controls;
		this.denghichuyenkhosService.listKhoChuyen(this.selectId_HH).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKhoChuyen = res.data;
				this.filteredKhoChuyen.next(this.listKhoChuyen.slice());
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	filterKhoChuyen() {
		if (!this.listKhoChuyen) {
			return;
		}
		// get the search keyword
		let search = this.KhoChuyenFilterCtrl;
		if (!search) {
			this.filteredKhoChuyen.next(this.listKhoChuyen.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredKhoChuyen.next(
			this.listKhoChuyen.filter(ts =>
				ts.TenKho.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	// ListKhoNhan() {
	// 	let controls = this.DeNghiChuyenKhoCTForm.controls;
	// 	this.denghichuyenkhosService.listKhoNhan(controls['khoChuyen'].value).subscribe(res => {
	// 		this.loadingSubject.next(false);
	// 		if (res && res.status === 1) {
	// 			this.listKhoNhan = res.data;
	// 			this.filteredKhoNhan.next(this.listKhoNhan.slice());
	// 			this.changeDetectorRefs.detectChanges();
	// 		};
	// 	});
	// }
	filterKhoNhan() {
		if (!this.listKhoNhan) {
			return;
		}
		// get the search keyword
		let search = this.KhoNhanFilterCtrl;
		if (!search) {
			this.filteredKhoNhan.next(this.listKhoNhan.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredKhoNhan.next(
			this.listKhoNhan.filter(ts =>
				ts.TenKho.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	ValidateChangeNumberEvent(event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == '.') {
				count += 1;
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		// var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '0';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return '0,00';
		return new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	changeValueOfForm(controlName: string, event: any) {
		if (this.ValidateChangeNumberEvent(event)) {
			let tmpValue = this.DeNghiChuyenKhoCTForm.controls[controlName].value.replace(/,/g, "");
			this.DeNghiChuyenKhoCTForm.controls[controlName].setValue(
				this.f_currency_VND(this.formatNumber(tmpValue))
			);
		}
		else {
			this.DeNghiChuyenKhoCTForm.controls[controlName].setValue(event.target.value);
		}
	}
	/*begin kéo thả cột */
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.Loadcolumntable();
		}
	}
	Loadcolumntable() {
		this.displayedColumns = [];
		this.availableColumns.forEach(item => this.displayedColumns.push(item.name));
	}
	/*end kéo thả cột */
	/* formatnumber for calculate */
	FormatCommaNumber(item: string) {
		return item.replace(/,/g, "");
	}
	/*end  formatnumber for calculate*/
	/*format datetime */
	FormatDatetime(datetime) {
		return this.datePipe.transform(datetime, 'dd/MM/yyyy');
	}
	/*end format datetime*/
	f_convertDateTime(date: string) {
		var componentsDateTime = date.split("/");
		var date = componentsDateTime[0];
		var month = componentsDateTime[1];
		var year = componentsDateTime[2];
		var formatConvert = year + "-" + month + "-" + date + "T00:00:00.0000000";
		return new Date(formatConvert);
	}
	f_convertDate(p_Val: any) {
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return a.getFullYear() + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + ("0" + (a.getDate())).slice(-2);
	}
	/*Đóng dialog và cập nhập lại tình trạng, trả về highlight ID nếu có*/
	back() {
		this.router.navigate(['de-nghi-chuyen-kho'], { queryParams: {}, skipLocationChange: false });
	}
	back_404() {
		this.router.navigate(['404'], { queryParams: {}, skipLocationChange: false });
	}
	clearSelectPhongBanDeNghi(event: any) {
		this.DeNghiChuyenKhoForm.controls["phongBanDeNghi"].setValue('');
		event.stopPropagation();
	}
	// HangHoaId(event: any) {
	// 	this.DeNghiChuyenKhoCTForm.controls["hangHoaId"].setValue('');
	// 	event.stopPropagation();
	// }
	clearSelectKhoChuyen(event: any) {
		this.DeNghiChuyenKhoCTForm.controls["khoChuyen"].setValue('');
		event.stopPropagation();
	}
	KhoNhan(event: any) {
		this.DeNghiChuyenKhoCTForm.controls["khoNhan"].setValue('');
		event.stopPropagation();
	}
	clearSelectTinhTrangCT(event: any) {
		this.DeNghiChuyenKhoCTForm.controls["tinhTrangCT"].setValue('');
		event.stopPropagation();
	}
	/* format number currency */
	validationSoLuong(soluong) {
		return soluong.match('^(([1-9][0-9]{0,2},([0-9]{3},)*)[0-9]{3}(\\.[0-9]{1,})?|([1-9]([0-9]+)?)(\\.[0-9]{1,})?|[0](\\.([1-9][0-9]?|[0][1-9])))$')
	}
	//#region Kiểm tra định dạng số lượng 
	keyUpInputKhoiLuong(event) {
		FunctionPublic.cvKeyUp(event);
	}
	changeInputKhoiLuong(event, columnName) {
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }
			let data = FunctionPublic.slListChanged(event);
			if (data) {
				this.DeNghiChuyenKhoForm.controls[columnName].setValue(data);
				this.changeDetect.detectChanges();
			}
		}
	}
	/* end */
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	convertTitleTinhTrang(code: string) {
		switch (code) {
			case this.optionsTinhTrang[0].value:
				return this.optionsTinhTrang[0].name;
			case this.optionsTinhTrang[1].value:
				return this.optionsTinhTrang[1].name;
			case this.optionsTinhTrang[2].value:
				return this.optionsTinhTrang[2].name;
			case this.optionsTinhTrang[3].value:
				return this.optionsTinhTrang[3].name;
			case this.optionsTinhTrang[4].value:
				return this.optionsTinhTrang[4].name;
			case this.optionsTinhTrang[5].value:
				return this.optionsTinhTrang[5].name;
			default:
				break;
		}
	}
	convertCodeTinhTrang(code: number) {
		switch (code) {
			case 0:
				return this.optionsTinhTrang[0].value;
			case 1:
				return this.optionsTinhTrang[1].value;
			case 2:
				return this.optionsTinhTrang[1].value;
			default:
				break;
		}
	}
	//get css for status
	getItemCssClassByStatus(status: string = ''): string {
		switch (status) {
			case this.optionsTinhTrang[1].value:
				return '_dangsoanthao';
			case this.optionsTinhTrang[2].value:
				return '_chotiepnhan';
			case this.optionsTinhTrang[3].value:
				return '_chokiemtra';
			case this.optionsTinhTrang[4].value:
				return '_chocapnhathuongxuly';
			case this.optionsTinhTrang[5].value:
				return '_hoantat';
		}
		return '';
	}
	addDetailDeNghiChuyenKho() {
		var constrols = this.DeNghiChuyenKhoCTForm.controls;
		if (this.DeNghiChuyenKhoCTForm.invalid) {
			Object.keys(constrols).forEach(controlName =>
				constrols[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
			// document.getElementById('dialog-formct').scrollTo({ top: 0, behavior: 'smooth' });
			return;
		}
		var itemHH = this.listHangHoaId.find(x => x.Id_HH == this.selectId_HH);
		var itemKhoChuyen = this.listKhoChuyen.filter(x => x.Id_Kho == constrols['khoChuyen'].value);
		var itemKhoNhan = this.listKhoNhan.filter(x => x.Id_Kho == constrols['khoNhan'].value);
		let item = new DeNghiChuyenKhoCTModel();
		item.clear();
		item.ListHH = [];
		//list DVT
		item.TextQuiDoiDVT = this.soLuong + ',00 ' + itemHH.TenDVT;
		if (itemHH.Dvt3 != null && itemHH.Dvt3 > 0){
			let tmp3 = { DVT: itemHH.Dvt3, QuiDoiDVT: itemHH.QuiDoiDVT3, TenDVT: itemHH.TenDVT3 };
			item.ListHH.push(tmp3);
		}
		if (itemHH.Dvt2 != null && itemHH.Dvt2 > 0){
			let tmp2 = { DVT: itemHH.Dvt2, QuiDoiDVT: itemHH.QuiDoiDVT2, TenDVT: itemHH.TenDVT2 };
			item.ListHH.push(tmp2);
		}
		let tmp = { DVT: itemHH.DVT, QuiDoiDVT: 1, TenDVT: itemHH.TenDVT };
		item.ListHH.push(tmp);

		item.ListHH  = item.ListHH.filter(x => x.DVT) // remove null
		let listIdHH = item.ListHH.map(x => x.DVT); 
		item.ListHH  = item.ListHH.filter((e, i) => listIdHH.indexOf(e.DVT) === i);
		//
		item.Id = 0;
		item.HangHoaId =  itemHH.Id_HH;
		item.TenHang = itemHH.TenHH;
		item.MaHang = itemHH.MaHH;
		item.QuyCach = constrols['quyCach'].value;
		item.Dvt = itemHH.DVT;
		item.TenDVTQuiDoi = itemHH.TenDVT
		item.DvtQuiDoi = constrols['DVTQuiDoi'].value;
		item.KhoChuyen = constrols['khoChuyen'].value;
		item.KhoNhan = constrols['khoNhan'].value;
		item.SLTon = constrols['sLTon'].value;
		item.SoLuong = this.soLuong;
		item.SoLuongQuiDoi = this.f_number(constrols['SoLuongQuiDoi'].value);
		item.SoLo = constrols['soLo'].value;
		item.SoMay = constrols['soMay'].value;
		item.MaSub = constrols['MaSub'].value;
		item.GhiChu = constrols['ghiChu'].value;
		item.SoMeSoXe = constrols['SoMeSoXe'].value;
		item.MaThung = constrols['MaThung'].value;
		item.Hansudung = constrols['Hansudung'].value;
		item.Ngaysanxuat = constrols['Ngaysanxuat'].value;
		item.TenKhoChuyen = itemKhoChuyen[0].TenKho;
		item.TenKhoNhan = itemKhoNhan[0].TenKho;
		item.SLThucNhap = this.f_number('0,00');
		item.SLThucXuat = this.f_number('0,00');
		//item.NgayDuyet = null;
		item.DeNghiChuyenKhoId = 0;
		item.ListKhoChuyen = this.listKhoChuyen;
		this.tmpDeNghiChuyenKhoCT.push(item);
		this.tmpDeNghiChuyenKhoCT = [...this.tmpDeNghiChuyenKhoCT];
		this.saveAddedCT.push(this.tmpDeNghiChuyenKhoCT.findIndex(x => x == item));
		//reset formgroup detail
		this.DeNghiChuyenKhoCTForm.reset();
		constrols['sLTon'].setValue('0,00');
		constrols['SoLuongQuiDoi'].setValue('0,00');
		constrols['maHang'].setValue('');
		constrols['maHang'].enable();
		this.soLuong = 0;
		this.textQuiDoiDVT = ""
		this.selectId_HH = "";
		this.listKhoChuyen = [];
		this.filteredKhoChuyen.next([]);
		this.keyWordSearchInListFrom.push("");
		this.keyWordSearchInListTo.push("");
		this.changeDetectView();
	}
	// getNameHH() {
	// 	let name = '';
	// 	if (this.listHangHoaId.length > 0) {
	// 		var item = this.listHangHoaId.filter(x => x.Id_HH == +this.DeNghiChuyenKhoCTForm.controls['hangHoaId'].value);
	// 		if (item.length > 0) name = item[0].MaHH;
	// 	}
	// 	return name ? name : '';
	// }
	changeHH(value: string) {
		if (this.listHangHoaId.length > 0) {
			this.selectId_HH = value;
			this.ListKhoChuyen();
			let controls = this.DeNghiChuyenKhoCTForm.controls;
			var itemHH = this.listHangHoaId.find(x => x.Id_HH == this.selectId_HH)
			controls['maHang'].setValue(itemHH.MaHH);
			controls['maHang'].disable();
			controls['tenHang'].setValue(itemHH.TenHH);
			controls['quyCach'].setValue(itemHH.QuyCachDongGoi);
			controls['Ngaysanxuat'].setValue(itemHH.Ngaysanxuat);
			controls['Hansudung'].setValue(itemHH.Hansudung);
			//controls['DVTQuiDoi'].setValue(itemHH[0].TenDVT);
			controls["DVTQuiDoi"].setValue('' + itemHH.DVT);
			var listDVTHH = []
			listDVTHH.push(itemHH.DVT);

			if (itemHH.Dvt3 != null && itemHH.Dvt3 > 0)
				listDVTHH.push(itemHH.Dvt3);
			if (itemHH.Dvt2 != null && itemHH.Dvt2 > 0)
				listDVTHH.push(itemHH.Dvt2);
			if(listDVTHH.length > 0) 

			// if((itemHH.TenNhomHH && itemHH.TenNhomHH.includes('NVL')) || 
			// 	(itemHH.TenNhomHH && itemHH.TenNhomHH.includes('HC')) || 
			// 	+itemHH.IdLoaiHH == 3){
			// 		controls["DVTQuiDoi"].setValue('' + listDVTHH[0]);
			// }else if((itemHH.TenNhomHH && itemHH.TenNhomHH.includes('BB - Nylon')) || +itemHH.IdLoaiHH == 1 || +itemHH.IdLoaiHH == 2){
			// 	controls["DVTQuiDoi"].setValue('' + itemHH.DVT);
			// }
			this.filteredListDVT.next(this.listDVT.filter(ts => listDVTHH.indexOf(ts.Id_DVT) > -1));
			this.changeDetectView();
		}
	}
	changeTuKho() {
		//this.ListKhoNhan();
	}
	formatComparenumber(number: string) {
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	getToTalSoLuongTon() {
		let controls = this.DeNghiChuyenKhoCTForm.controls;
		if (this.selectId_HH != '' && controls['khoChuyen'].value != '' && this.listKhoChuyen.length > 0) {
			let itemHH = this.listKhoChuyen.filter(x => x.Id_Kho == controls['khoChuyen'].value);
			controls['sLTon'].setValue(this.f_number(itemHH[0].TotalSoLuongTon + ''));
			this.changeDVT(1);

		}
	}
	generateAutoSoPhieu() {
		this.serMaster.getBillNumber(this.path).subscribe(res => {
			if (res && res.status == 1) {
				var controls = this.DeNghiChuyenKhoForm.controls;
				controls['soPhieu'].setValue(res.data);
				this.changeDetectView();
			}
		})
	}
	removeDetailDeNghiChuyenKho(index) {
		this.tmpDeNghiChuyenKhoCT.splice(index, 1);
		this.tmpDeNghiChuyenKhoCT = [...this.tmpDeNghiChuyenKhoCT];
		this.changeDetectView();
	}
	loadChiTietSLTon(event) {
		let controls = this.DeNghiChuyenKhoCTForm.controls;
		var itemHH = this.listHangHoaId.filter(x => x.Id_HH == this.selectId_HH);
		var itemKhoChuyen = this.listKhoChuyen.filter(x => x.Id_Kho == controls['khoChuyen'].value);
		this.openDialogDNChuyenKho = true;
		const dialogRef = this.dialog.open(DeNghiChuyenKhoChiTietHangComponent, {
			data: {
				hangHoaId: this.selectId_HH,
				khoChuyen: controls['khoChuyen'].value,
				TenHH: itemHH[0].TenHH,
				MaHH: itemHH[0].MaHH
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.openDialogDNChuyenKho = false;
			if (!res) {
				return;
			}
			if (!res.IsChange) {
				return;
			}
			this.changeDetectView();
		});
	}
	loadHistoryHHKhoXuat(item: DeNghiChuyenKhoCTModel) {
		this.openDialogDNChuyenKho = true;
		const dialogRef = this.dialog.open(DeNghiChuyenKhoHistoryHHKhoXuatComponent, {
			data: {
				Id: item.Id,
				MaHang:item.MaHang,
				TenHang:item.TenHang
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.openDialogDNChuyenKho = false;
			if (!res) {
				return;
			}
			if (!res.IsChange) {
				return;
			}
			this.changeDetectView();
		});
	}
	loadHistoryHHKhoNhap(item: DeNghiChuyenKhoCTModel) {
		this.openDialogDNChuyenKho = true;
		const dialogRef = this.dialog.open(DeNghiChuyenKhoHistoryHHKhoNhapComponent, {
			data: {
				Id: item.Id,
				MaHang:item.MaHang,
				TenHang:item.TenHang
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.openDialogDNChuyenKho = false;
			if (!res) {
				return;
			}
			if (!res.IsChange) {
				return;
			}
			this.changeDetectView();
		});
	}
	/** SELECTION */
	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.tmpDeNghiChuyenKhoCT.length;
		return numSelected === numRows;
	}
	/** Selects all rows if they are not all selected; otherwise clear selection. */
	masterToggle() {
		if (this.isAllSelected()) {
			this.selection.clear();
		} else {
			this.tmpDeNghiChuyenKhoCT.forEach(row => this.selection.select(row));
		}
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }
			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (this.formatComparenumber(data) < min && event.data && event.data == '0') data = this.f_currency_VND(this.formatNumber(min.toString()));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
			} else {
				controls[columnName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");
			if (Number(tmpValue) < min) tmpValue = min;
			if (!controls[controlName].invalid) {
				controls[controlName].setValue(
					this.f_currency_VND(this.formatNumber(tmpValue))
				);
			}
			if (tmpValue.indexOf(',') == 0 && tmpValue.length == 1) {
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_currency_VND(this.formatNumber(tmpValue))
			);
		}
		else {
			controls[controlName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
		}
	}
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ',') {
					count += 1;
				}
			}
		}
		else {
			event = "" + event
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ',') {
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	highlightNewestRecord(currentPosition: number) {
		if (this.saveAddedCT.findIndex(x => x == currentPosition) > -1) {
			return true;
		}
		return false;
	}

	changHeightViewPort() {
		let count;
		if (this.arrHangHoa.length == 0) {
			count = 0;
		} else {
			count = this.arrHangHoa[0]._events[0].length;
		}
		if (count >= 5) {
			return '200px';
		} else if (count == 4) {
			return '150px';
		} else if (count == 3) {
			return '120px';
		} else if (count == 2) {
			return '90px';
		} else if (count == 1) {
			return '50px';
		} else {
			return '0px';
		}
	}
	clearSelectHangHoa(event: any) {
		this.searchWithKeyword();
		var controls = this.DeNghiChuyenKhoCTForm.controls;
		this.selectId_HH = "";
		controls['tenHang'].setValue('');
		controls['maHang'].setValue('');
		controls['quyCach'].setValue('');
		controls['DVTQuiDoi'].setValue('');
		controls['sLTon'].setValue('0,00');
		controls['khoChuyen'].setValue("");
		controls['maHang'].enable();
		this.listKhoChuyen = [];
		this.filteredKhoChuyen.next([]);
		this.filteredHangHoaId.next(this.listHangHoaId.slice());
		this.getListWareHouse();
		this.changeDetectView();
	}
	keyUpInputNumberVND(event) {
		FunctionPublic.cvKeyUp(event);
	}
	openChange($event: boolean) {
		if ($event) {
			this.cdkVirtualScrollViewPort.scrollToIndex(0);
			this.cdkVirtualScrollViewPort.checkViewportSize();
		}
	}
	changeValueOfForm_ListDetail(columnName: string, event: any, index, indexdropdown = 0) {
		if (columnName == 'SoLuong') {
			let SoLuong = this.formatComparenumber(event.target.value);
			this.tmpDeNghiChuyenKhoCT[index].SoLuong = this.f_number(SoLuong+'');
		}
		this.tmpDeNghiChuyenKhoCT = [...this.tmpDeNghiChuyenKhoCT];
		this.changeDetectView();
	}

	// Update Đề nghị chuyển kho  ngày 08.03.2021 by Phong
	// Hàm lấy danh sách kho đang được sử dụng trên hệ thống 
	// Hiển thị lên danh sách "Đến kho"
	// Params id_kho - danh sách ẩn đi kho có chứa id_kho này
	getListWareHouse(id_kho: number = 0){
		if(this.DeNghiChuyenKhoCTForm && this.DeNghiChuyenKhoCTForm.controls['khoChuyen'].value == this.DeNghiChuyenKhoCTForm.controls['khoNhan'].value)
			this.DeNghiChuyenKhoCTForm.controls['khoNhan'].setValue('');
		this.serMaster.listKho().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKhoNhan = id_kho > 0 ? res.data.filter(x => x.Id_Kho != id_kho) : res.data;
				this.filteredKhoNhan.next(this.listKhoNhan.slice());
				this.getToTalSoLuongTon();
				this.changeDetectorRefs.detectChanges();
			};
		});
	}

	// Function tìm kiếm theo kí tự search
	// Danh sách kho
	// Params từ khóa search kw, danh sách kho - i: vị trí của từ khóa search
	searchWareHouseFromKeyWords(list: any[] = [], search: string = "", item: DeNghiChuyenKhoCTModel = null){
		search = search.toLowerCase();
		var list = list.filter(ts => ts.TenKho.toLowerCase().indexOf(search) > -1);
		if(item != null)
		{
			if(+item.KhoChuyen > 0 && +item.KhoNhan > 0 && +item.KhoNhan == +item.KhoChuyen)
			{
				item.KhoNhan = 0;
				this.tmpDeNghiChuyenKhoCT = [...this.tmpDeNghiChuyenKhoCT];
			}
			list = list.filter(ts => ts.Id_Kho != item.KhoChuyen);
		}
		return list;
	}

	searchWithKeyword(){
		//this.loadingMerchandise.next(true);
		this.keywordChanged.next(this.HangHoaIdFilterCtrl);
		this.changeDetectView();
	}
	triggerMerchandise(){
		//return !this.DeNghiChuyenKhoCTForm.controls['maHang'].value ? "" : this.listHangHoaId.find(x => x.Id_HH == Number(this.DeNghiChuyenKhoCTForm.controls['hangHoaId'].value)).MaHH;
		return !this.selectId_HH ? "" : this.listHangHoaId.find(x => x.Id_HH == Number(this.selectId_HH)).MaHH;
	}

	// #region Format Number
	// .. Hàm sử dụng cho sự kiện change format số trên form
	cvInputFormNumber(controlName: string, event: any, min: number = 0, formGroup){
		const VALUE_EMPTY  = "";
		const MIN_VALUE    = min;
		const REGEX_COMMA  = /,/g;
		const VALUE_DEFAULT= 0.00000;
		var   controls 	   = formGroup.controls;
		var   valueControl = controls[controlName].value;
		// .. Giá trị trống thì lấy giá trị min
		if (valueControl == VALUE_EMPTY) controls[controlName].setValue(this.f_number(MIN_VALUE));
		// .. Giá trị không xác thực gán lại 0.0
		if (isNaN(valueControl))	valueControl = VALUE_DEFAULT;
		// .. Giá trị nhỏ hơn min thì = min
		if (Number(valueControl) < min) valueControl = MIN_VALUE;
		// .. Valid mới set giá trị
		if (!controls[controlName].invalid) controls[controlName].setValue(this.f_number(valueControl));
		// .. Giá trị "," thì gán về min
		if (valueControl.toString().indexOf(REGEX_COMMA) == 0 && valueControl.length == 1) valueControl = MIN_VALUE;
		controls[controlName].setValue(this.f_number(valueControl));
	}
	// .. Hàm sử dụng cho sự kiện change format số trên table
	cvInputListNumber(columnName: string, event: any, min: number = 0, item: DeNghiChuyenKhoCTModel){
		const VALUE_EMPTY  = "";
		const MIN_VALUE    = min;
		const REGEX_COMMA  = /,/g;
		const INDEX_ZERO   = 0;
		const VALUE_DEFAULT= 0.00000;
		var   value 	   = item[columnName];
		var   evtValue     = event.target.value;
		var   evtTarget    = event.target;
		if ((evtValue == VALUE_EMPTY) || (evtValue.toString() == value.toString())){
			if (evtValue == VALUE_EMPTY) evtTarget.value = this.f_number(MIN_VALUE);
			if (evtValue.toString() == value.toString()) evtTarget.value = this.f_number(value);
			evtTarget.selectionStart = INDEX_ZERO; 
			evtTarget.selectionEnd   = INDEX_ZERO;
		}
		if (!this.ValidateChangeNumberForm(event))
		{
			item[columnName] = MIN_VALUE; 
			return false;
		}
		if (isNaN(evtValue)) evtValue = VALUE_DEFAULT;
		if (Number(evtValue) < min) evtValue = MIN_VALUE;
		if (!item[columnName]) item[columnName] = MIN_VALUE;
		item[columnName] = evtValue;
		evtTarget.value = this.f_number(evtValue);
		this.changeDetect.detectChanges();
	}
	// .. Điều chỉnh hàm format
	f_number(item: any = "0.00000") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, FunctionPublic.MAX_POINT);
	}
	// #endregion
	ListDVT() {
		this.serMaster.getDSDonViTinh().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listDVT = res.data;
				this.filteredListDVT.next(this.listDVT.slice());
				this.changeDetectView()
			};
		});
	}

	filterDVT() {
		if (!this.listDVT) {
			return;
		}
		let search = this.ListDVTFilterCtrl;

		if (this.DeNghiChuyenKhoCTForm.controls["MAHH"].value != null &&
			this.DeNghiChuyenKhoCTForm.controls["MAHH"].value != '') {

			let item = this.listHangHoaId.find(x => x.Id_HH == +this.selectId_HH);
			if (item != null) {
				var listDVTHH = []
				listDVTHH.push(item.DVT);
				if (item.Dvt2 != null && item.Dvt2 > 0)
					listDVTHH.push(item.Dvt2);
				if (item.Dvt3 != null && item.Dvt3 > 0)
					listDVTHH.push(item.Dvt3);

				if (!search) {
					this.filteredListDVT.next(
						this.listDVT.filter(ts => listDVTHH.indexOf(ts.Id_DVT) > -1)
					);
					return;
				} else {
					search = search.toLowerCase();
				}
				this.filteredListDVT.next(
					this.listDVT.filter(ts =>
						listDVTHH.indexOf(ts.Id_DVT) > -1 &&
						ts.TenDVT.toLowerCase().indexOf(search) > -1)
				);
			}
			else {
				if (!search) {
					this.filteredListDVT.next(this.listDVT.slice());
					return;
				} else {
					search = search.toLowerCase();
				}
				this.filteredListDVT.next(
					this.listDVT.filter(ts =>
						ts.TenDVT.toLowerCase().indexOf(search) > -1)
				);
			}
		}
		else {
			if (!search) {
				this.filteredListDVT.next(this.listDVT.slice());
				return;
			} else {
				search = search.toLowerCase();
			}
			this.filteredListDVT.next(
				this.listDVT.filter(ts =>
					ts.TenDVT.toLowerCase().indexOf(search) > -1)
			);
		}

		this.changeDetectView();
	}
	changeDVT(flag: number) {
		this.listHangHoaId.forEach(element => {
			if (element.Id_HH == +this.selectId_HH) {
				var listDVTHH = []
				listDVTHH.push(element.DVT);
				if (element.Dvt2 != null && element.Dvt2 > 0)
					listDVTHH.push(element.Dvt2);
				if (element.Dvt3 != null && element.Dvt3 > 0)
					listDVTHH.push(element.Dvt3);

				let currentDVT = listDVTHH.findIndex(x => x == +this.DeNghiChuyenKhoCTForm.controls["DVTQuiDoi"].value)
				if (currentDVT == 1) {
					var numQuiDoi = Number(this.f_number(this.DeNghiChuyenKhoCTForm.controls["SoLuongQuiDoi"].value))
						* Number(element.QuiDoiDVT2)
					if (numQuiDoi > 0){
						this.soLuong = numQuiDoi;
					}
					if(flag == 1){
						this.textQuiDoiDVT = this.f_number(Number(this.f_number(this.DeNghiChuyenKhoCTForm.controls["sLTon"].value)) / Number(element.QuiDoiDVT2)) + ' ' + element.TenDVT2;
						this.soLuongDaQuiDoi = this.f_number(Number(this.f_number(this.DeNghiChuyenKhoCTForm.controls["sLTon"].value)) / Number(element.QuiDoiDVT2))
					}
				}
				else if (currentDVT == 2) {
					var numQuiDoi = Number(this.f_number(this.DeNghiChuyenKhoCTForm.controls["SoLuongQuiDoi"].value))
						* Number(element.QuiDoiDVT3)
					if (numQuiDoi > 0){
						this.soLuong = numQuiDoi;
					}
					if(flag == 1){
						this.textQuiDoiDVT = this.f_number(Number(this.f_number(this.DeNghiChuyenKhoCTForm.controls["sLTon"].value)) / Number(element.QuiDoiDVT3)) + ' ' + element.TenDVT3;
						this.soLuongDaQuiDoi = this.f_number(Number(this.f_number(this.DeNghiChuyenKhoCTForm.controls["sLTon"].value)) / Number(element.QuiDoiDVT3));
					}
				}
				else if (currentDVT == 0) {
					if(flag == 1){
						this.textQuiDoiDVT = this.f_number(Number(this.f_number(this.DeNghiChuyenKhoCTForm.controls["sLTon"].value))) + ' ' + element.TenDVT;
						this.soLuongDaQuiDoi = this.f_number(Number(this.f_number(this.DeNghiChuyenKhoCTForm.controls["sLTon"].value)));
					}
					this.soLuong =  Number(this.f_number(this.DeNghiChuyenKhoCTForm.controls["SoLuongQuiDoi"].value));
				}
				this.changeDetectView();
			}
		});
	}
	changeDVTDetail(item) {
		this.listHangHoaId.forEach(element => {
			if (element.Id_HH == item.HangHoaId) {
				var listDVTHH = []
				listDVTHH.push(element.DVT);
				if (element.Dvt2 != null && element.Dvt2 > 0)
					listDVTHH.push(element.Dvt2);
				if (element.Dvt3 != null && element.Dvt3 > 0)
					listDVTHH.push(element.Dvt3);

				let currentDVT = listDVTHH.findIndex(x => x == item.DvtQuiDoi)
				if (currentDVT == 1) {
					var numQuiDoi = Number(this.f_number( Number(item.SoLuongQuiDoi)+',00'))
						* Number(element.QuiDoiDVT2)
					if (numQuiDoi > 0){
						item.TextQuiDoiDVT = this.f_number(numQuiDoi) + ' ' + element.TenDVT;
						item.Soluong = numQuiDoi;
					}
				}
				else if (currentDVT == 2) {
					var numQuiDoi = Number(this.f_number( Number(item.SoLuongQuiDoi)+',00'))
						* Number(element.QuiDoiDVT3)
					if (numQuiDoi > 0){
						item.TextQuiDoiDVT = this.f_number(numQuiDoi) + ' ' + element.TenDVT;
						item.Soluong = numQuiDoi;
					}
				}
				else if (currentDVT == 0) {
					item.TextQuiDoiDVT = this.f_number(item.SoLuongQuiDoi) + ' ' + element.TenDVT;
					item.Soluong = Number(this.f_number( Number(item.SoLuongQuiDoi)+',00'));
				}
			}
		});
	}
	showOverLoad() {
		var khoiLuong = this.f_number(
			this.DeNghiChuyenKhoCTForm.controls["SoLuongQuiDoi"].value
		);
		var soLuongTon = this.f_number(this.soLuongDaQuiDoi);
		return Number(khoiLuong) > Number(soLuongTon);
	}
	isOverLoad(){
		var khoiLuong = this.f_number(
			this.DeNghiChuyenKhoCTForm.controls["SoLuongQuiDoi"].value
		);
		var soLuongTon = this.f_number(this.soLuongDaQuiDoi);
		return (Number(khoiLuong) > Number(soLuongTon))?true:false;
	}
	isEqual0(){
		var khoiLuong = this.f_number(
			this.DeNghiChuyenKhoCTForm.controls["SoLuongQuiDoi"].value
		);
		
		return khoiLuong == 0;
	}
	filterRequestDepartment() {
		const search = this.requestDepartmentFtrCtrl;
		if (!this.orgStructureTree) return;
		if (!search) {
			this.ftrRequestDepartment.next([...this.orgStructureTree]);
			return;
		}
		const lowerCaseSearch = search.toLowerCase().trim();
		this.ftrRequestDepartment.next(
			this.orgStructureTree.filter(ts =>
				ts.TenPB.toLowerCase().includes(lowerCaseSearch)
			)
		);
		this.changeDetectView();
	}
}
